export default __webpack_public_path__ + "assets/951859af1df5f7d928b30d637d162380.png";